import httpClient from '@/apis/base/httpclient';
import SystemApi from './_systemApi';

class DatabaseAPI extends SystemApi {
  constructor() {
    super();
  }
  controllerName = 'databases';

  /**
   * Lấy dữ liệu cho popup chọn dữ liệu làm việc
   */
  getDatabases(payload) {
    let request = {url: [this.getAPIUrl(), `?takeAll=${payload?.takeAll || ''}`].join('')};

    return httpClient.getAsync(request);
  }

  /**
   * Đổi tên dữ liệu
   */
  updateDatabaseName(model) {
    let request = {
      url: [this.getAPIUrl(), 'rename'].join('/'),
      data: model,
    };

    return httpClient.putAsync(request);
  }

  /**
   * Cập nhật ngày hạch toán
   * lttuan1 - 26.05.2023
   */
  updatePostedDate(model) {
    let request = {
      url: [this.getAPIUrl(), 'posteddate'].join('/'),
      data: model,
    };

    return httpClient.putAsync(request);
  }

  /**
   * Xóa dữ liệu
   */
  deleteDatabase(model) {
    let request = {
      url: [this.getAPIUrl(), 'delete'].join('/'),
      data: model,
    };

    return httpClient.deleteAsync(request);
  }

  /**
   * Lấy dữ liệu thông tin Đơn vị
   */
  getTenant(userId) {
    let request = {
      url: [this.getAPIUrl(), `tenant?userId=${userId}`].join('/'),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu thông tin database
   */
  getInfo(databaseId) {
    let request = {
      url: [this.getAPIUrl(), `info`].join('/'),
      data: {
        database_id: databaseId,
      },
    };

    return httpClient.postAsync(request);
  }

  checkValidDatabaseName(payload) {
    let request = {
      url: [this.getAPIUrl(), `/checkExistDatabaseName?databaseName=${payload.databaseName}`].join(''),
    };
    return httpClient.getAsync(request);
  }

  getNotiStatus(databaseId) {
    let request = {
      url: [this.getAPIUrl(), `/noti?databaseId=${databaseId}`].join(''),
    };
    return httpClient.getAsync(request);
  }

  getUpgradeInfo() {
    let request = {
      url: [this.getAPIUrl(), `/upgrade/info`].join(''),
    };
    return httpClient.getAsync(request);
  }

  /**
   * Cập nhật trạng thái làm việc ngoại tuyến
   */
  updateUseOffline(model) {
    let request = {
      url: [this.getAPIUrl(), 'changeUseOffline'].join('/'),
      data: model,
    };

    return httpClient.putAsync(request);
  }
  /**
   * Ghi log thời gian mất mạng (Mã QHNS, thời điểm mất mạng, thời điểm có mạng)
   */
  logTimeOffline(param){
    let request = {
      url: this.getAPIUrl() + '/LogTimeOffline',
      data: param,
    };
    return this.postAsync(request);
  }
}

export default new DatabaseAPI();
